import { createContext } from "react";
const ThemeSettingContext = createContext({
  toggle: () => {
  },
  set: (_) => {
  },
  themes: []
});
export {
  ThemeSettingContext
};
//# sourceMappingURL=ThemeSettingContext.js.map
